/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-19 16:58:18
 * @LastEditors: K
 * @LastEditTime: 2022-09-27 13:48:27
 */
import {
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, notification, Row, Select, Space } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { ThemeContext } from '../../theme/ThemeContext'
import { HerbsDirectoryModal } from './compnents/HerbsDirectoryModal'
import styles from './ReplaceMakeSupplier.module.css'
import { herbsColumns } from './ReplaceMakeSupplierColumns'
import { getAddHerbsList, getDeleteHerbsList, getHerbsList, getReplaceMakeSupplierList } from './ReplaceMakeSupplierSclice'


interface HerbsDirectoryProps {
  state: string
}
export const HerbsDirectory = ({ state }: HerbsDirectoryProps): ReactElement => {

  const theme = useContext(ThemeContext)
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [params, setParams] = useState<any>({
    size: 10,
    current: 0,
  })

  const [page, setPage] = useState<any>({
    items: [],
    total: 10
  })

  const [pageLoading, setPageLoading] = useState(false)


  const [herbsDirectoryModalShow, setHerbsDirectoryModalShow] = useState(false)

  const [modalText, setModalText] = useState(0)

  const [editData, setEditData] = useState<any>()

  const [btnLoading, setBtnLoading] = useState(false)



  const getPageFn = () => {
    setPageLoading(true)
    dispatch(getHerbsList({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])
  useEffect(() => {
    form.submit()
  }, [])
  useEffect(() => {
    params.current && getPageFn()
  }, [params])
  return (
    <div className={styles.wrap}>
      <div className={styles.contentWrap}>
        <Form
          form={form}
          autoComplete='off'
          initialValues={{}}
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              current: 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            style={{ margin: '10px 0 20px', width: '100%' }}
          >
            <Space>
              <Form.Item name='name' noStyle>
                <Input
                  allowClear
                  placeholder='请输入商品名称'
                  prefix={<SearchOutlined />}
                  style={{ width: '315px' }}
                  onChange={form.submit}
                />
              </Form.Item>

            </Space>
            <Space>
              <Button type='primary' onClick={() => {
                setModalText(0)
                setHerbsDirectoryModalShow(true)
                setEditData(undefined)
              }}>
                新增
              </Button>
            </Space>
          </Row>
        </Form>

          <EditableList
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            loading={pageLoading}
            style={{ color: theme.tc3 }}
            className={styles.table}
            columns={herbsColumns(
              (action, t) => {
                switch (action) {
                  case 'edit':
                    setModalText(1)
                    setEditData(t)
                    setHerbsDirectoryModalShow(true)
                    break
                  case 'delete':
                    dispatch(getDeleteHerbsList({ id: t.id }))
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({ message: '删除成功' })
                        setParams({ ...params })
                      })
                    break

                }
              }, (params.size || 10) * ((params.current || 1) - 1)
            )}
          onChangePage={(current, size) => {
            setParams({ ...params, current, size })
          }}
        />
      </div>

      <HerbsDirectoryModal
        visible={herbsDirectoryModalShow}
        editData={editData}
        onOk={(data) => {
          dispatch(getAddHerbsList(data))
            .then(unwrapResult)
            .then(() => {
              notification.success({ message: `${modalText ? '编辑' : '新增'}成功` })
              setHerbsDirectoryModalShow(false)
              setParams({ ...params })
            })
            .finally(() => setBtnLoading(!btnLoading))
        }}
        onCancel={() => setHerbsDirectoryModalShow(false)}
        btnLoading={btnLoading}

      />
    </div>
  );
}

